'use client';
import NextLink from 'next/link';

import { sizeClassnames, variantClassnames } from '@/server/components/Button/helpers';

import css from './Button.module.scss';

export const ButtonLink = ({
  href,
  children,
  variant,
  size = 'md',
  clipboardTarget: clipboardTargetRaw,
  useWindow = false,
}: {
  href: string;
  children: React.ReactNode;
  variant: keyof typeof variantClassnames;
  size?: keyof typeof sizeClassnames;
  clipboardTarget?: string;
  useWindow?: boolean;
}) => {
  const clipboardTarget = useWindow && typeof window !== 'undefined' ? window.location.href : clipboardTargetRaw;
  const shouldCopy = !!clipboardTarget;
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (shouldCopy) {
      e.preventDefault();
      void (async () => {
        try {
          await navigator.clipboard.writeText(clipboardTarget);
          window.location.replace(href);
        } catch (e) {
          throw Error('Your browser does not seem to support copying to clipboard');
        }
        window.location.replace(href);
      })();
    }
  };

  return (
    <NextLink
      href={href}
      target="_self"
      className={`${css.button} ${variantClassnames[variant]} ${sizeClassnames[size]}`}
      legacyBehavior={shouldCopy}
      passHref={shouldCopy}
    >
      <>
        {shouldCopy && (
          <a
            href={href}
            className={`${css.button} ${variantClassnames[variant]} ${sizeClassnames[size]}`}
            onClick={onClick}
          >
            {children}
          </a>
        )}
        {!shouldCopy && <>{children}</>}
      </>
    </NextLink>
  );
};
